import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'

const DeployViewWrapper = React.lazy(async () => ({
    default: (await import('@oc/deployment/module')).DeployViewWrapper
}))

export function DeploymentComponent() {
    return <SuspenseWhileLoading LazyComponent={DeployViewWrapper} />
}

const MassDeploy = React.lazy(async () => ({
    default: (await import('@oc/deployment/module')).MassDeploy
}))

export function MassDeployComponent() {
    return <SuspenseWhileLoading LazyComponent={MassDeploy} />
}
